import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { PeselInput as PeselInputComponent } from '@dreryk/react-components';

export type PeselValue = { pesel: Pesel | null };
type PeselInputProps = Pick<FormContextValues<PeselValue>, 'register'>;

export const PeselInput = (props: PeselInputProps): JSX.Element => {
   const controller = props.register('pesel', {
      required: true,
   });

   return <PeselInputComponent label={commonTranslationKeys.pesel} controller={controller} testId={'pesel'} />;
};
